import { render, staticRenderFns } from "./ColumnOperate.vue?vue&type=template&id=5c71e5aa&scoped=true"
import script from "./ColumnOperate.vue?vue&type=script&lang=ts"
export * from "./ColumnOperate.vue?vue&type=script&lang=ts"
import style0 from "./ColumnOperate.vue?vue&type=style&index=0&id=5c71e5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71e5aa",
  null
  
)

export default component.exports